import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { HERO_IMG, WA_MAIN } from "@/data/content";

export const Hero = () => {
  const { t } = useLang();
  const h = t.hero;

  return (
    <section id="hero" className="relative pt-[74px] bg-paper overflow-hidden">
      <div className="max-w-[88rem] mx-auto grid grid-cols-1 lg:grid-cols-12 items-stretch">
        {/* Text */}
        <div className="lg:col-span-7 px-5 md:px-10 py-14 md:py-20 flex flex-col justify-center">
          <motion.p
            initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}
            className="font-semibold text-sm md:text-base text-ink/60 mb-5"
          >
            {h.role}
          </motion.p>

          <motion.h1
            initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.1 }}
            data-testid="hero-title"
            className="font-extrabold text-ink tracking-tight leading-[0.98] text-5xl sm:text-6xl md:text-7xl lg:text-[5.4rem]"
          >
            {h.pre}<br />
            <span className="hl-marker">{h.highlight}</span> {h.post}
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.25 }}
            className="font-normal text-base md:text-lg text-ink/70 max-w-xl mt-7 leading-relaxed"
          >
            {h.subtitle}
          </motion.p>

          <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.4 }}>
            <a
              data-testid="hero-cta"
              href={WA_MAIN}
              target="_blank"
              rel="noopener noreferrer"
              className="group mt-10 inline-flex items-center gap-4 font-bold text-base bg-ink text-white rounded-full pl-7 pr-2 py-2 hover:bg-brand hover:text-ink transition-colors duration-300 w-fit"
            >
              {h.cta}
              <span className="h-11 w-11 rounded-full bg-brand text-ink flex items-center justify-center group-hover:bg-ink group-hover:text-brand transition-colors duration-300">
                <ArrowRight size={20} />
              </span>
            </a>
          </motion.div>
        </div>

        {/* Portrait on yellow block */}
        <div className="lg:col-span-5 relative min-h-[440px] sm:min-h-[560px] lg:min-h-[620px] flex items-end justify-center bg-brand">
          <motion.img
            initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
            src={HERO_IMG}
            alt="Said Kalil"
            className="relative z-10 h-full w-auto object-contain object-bottom drop-shadow-2xl"
          />
        </div>
      </div>
    </section>
  );
};
